var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClipboardCheck = function SvgClipboardCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.8H17.25C17.7141 4.8 18.1592 4.98964 18.4874 5.32721C18.8156 5.66477 19 6.12261 19 6.6V19.2C19 19.6774 18.8156 20.1352 18.4874 20.4728C18.1592 20.8104 17.7141 21 17.25 21H6.75C6.28587 21 5.84075 20.8104 5.51256 20.4728C5.18437 20.1352 5 19.6774 5 19.2V6.6C5 6.12261 5.18437 5.66477 5.51256 5.32721C5.84075 4.98964 6.28587 4.8 6.75 4.8H8.5M9.375 13.8L11.125 15.6L14.625 12M9.375 3H14.625C15.1082 3 15.5 3.40294 15.5 3.9V5.7C15.5 6.19706 15.1082 6.6 14.625 6.6H9.375C8.89175 6.6 8.5 6.19706 8.5 5.7V3.9C8.5 3.40294 8.89175 3 9.375 3Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClipboardCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "clipboard-check.92905249009d58618668ab3b9b9dc11a.svg";